import { useFela } from 'react-fela';
import classnames from 'classnames';

import ImageUploader from '../../containers/ImageUploader';
import ImageList from '../../containers/ImageList';

import rule from './Images.rule';

const Images = () => {
    const { css } = useFela();

    return (
        <div className={classnames('Images', css(rule))}>
            <ImageUploader />
            <ImageList />
        </div>
    );
};

export default Images;
